/*eslint-disable */
import {
  bus
} from '../../main';
import adapter from 'webrtc-adapter';
const $ = window.jQuery = require('jquery');
export default {
  name: 'user-acknowledgement-popup',
  components: {},
  props: [],
  data () {
    return {
      acknowledgement:true
    }
  },
  computed: {

  },
  mounted () {

  },
  beforeMount() {
  },
  methods: {
    getUserDetailsAgain() {
      this.$store.dispatch('getAcUserDetailsFun').then((res) => {
      }).catch((err) => {
      })
    },
    closeAcknowModal(){
      let data = {
      user: {
        acknowledgement:this.acknowledgement
      },
    }
      this.$store.dispatch('updateProfileFun', data)
      .then((res) => {
        this.getUserDetailsAgain()
        bus.$emit('userAcknowledgementEmitter', false);
        $('body').removeClass('acknowledgement_popup_show')
      }).catch((err) => {
      })
    return;

    }
  },
}


